<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-ac-title">
      {{$t('maintenance.access_control.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-ac-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-ac-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-ac-name-label">
                  {{ $t('maintenance.access_control.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-ac-form-name"
                  type="text"
                  v-model="acForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.access_control.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-ac-provisioning-label">
                  {{ $t('maintenance.access_control.create.provisioning_label') }}
                </label>
                <b-form-radio-group
                  v-model="acForm.provisioning"
                  :options="radioOptions"
                  qid="create-ac-form-provisioning"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <label qid="create-ac-certification-label">
                  {{ $t('maintenance.access_control.create.certification_label') }}
                </label>
                <b-form-radio-group
                  v-model="acForm.re_certification"
                  :options="radioOptions"
                  qid="create-ac-form-certification"
                ></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-ac-cancel-button"
              >
                {{ $t('maintenance.access_control.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-ac-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.access_control.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateAccessControl',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.access_control.title'),
            to: '/maintenance/access-control'
          },
          {
            text: this.$t('maintenance.access_control.create.title'),
            active: true
          }
        ],
        acForm: {
          name: '',
          provisioning: '',
          re_certification: '',
          client:'',
        },
        error: '',
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/access-control')
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.acForm.name);
        formData.append("provisioning", this.acForm.provisioning);
        formData.append("re_certification", this.acForm.re_certification);
        formData.append("client", this.getClient.slug);

        // Post FormData object to API
        piincHttp.post('/access-controls', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.access_control.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            // Print whole array of actual errors beside message
            self.error = self.error + '\n\n' + JSON.stringify(error.data.errors);
          }
        })
      },
    },
    components: {

    },
    created () {

    }
  }
</script>
